module.exports = __webpack_public_path__ + "static/media/TargetaGeneral.f875aa8a.svg";